"use client";

import { useEffect, type ReactElement } from "react";
import { scheduleIdle } from "@/lib/scheduleIdle";

function injectGa(gaId: string): void {
  if (document.querySelector(`script[data-ga="${gaId}"]`)) return;

  const loader = document.createElement("script");
  loader.async = true;
  loader.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  loader.dataset.ga = gaId;
  document.head.appendChild(loader);

  const init = document.createElement("script");
  init.dataset.ga = gaId;
  init.text = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${gaId}');`;
  document.head.appendChild(init);
}

/** Loads GA after idle so it stays off the LCP / critical request chain. */
export default function GoogleAnalytics(): ReactElement | null {
  const gaId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

  useEffect(() => {
    if (!gaId) return;
    return scheduleIdle(() => injectGa(gaId), 4000);
  }, [gaId]);

  return null;
}
